<template>
  <div class="bankruptcyNews" v-wechat-title="$route.meta.title">
    <Header/>
    <BannerBg/>
    <div class="home_main_box">
      <div class="site_width">
        <div class="Practices_title">
          <h1>{{routeParams.columnName}}</h1>
        </div>
      </div>
      <div class="news_page_box">
        <div class="site_width">
          <div class="padding15">
            <div class="padding15 news_info_list">
              <ul>
                <li v-for="item in tableData" :key="item.id">
                  <a @click="contentTo(item.id)">
                    <p class="pc_only news_info_pc">{{ item.title }} <span>{{ formatDate(item.created) }}</span></p>
                    <p class="phone_only news_info_phone">{{ item.title }} <span>{{ formatDate(item.created) }}</span></p>
                  </a>
                  <div class="clear"></div>
                </li>
              </ul>
            </div>
            <div class="pagination_box">
              <el-pagination
                class="formPagination"
                background
                :pager-count="5"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageParams.pageNo"
                :page-size="pageParams.pageSize"
                layout="prev, pager, next"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  export default {
    name: "bankruptcyNews",
    data() {
      return {
        defaultImg: require('@/assets/images/news_default.jpg'),
        pageParams: {
          title: null,
          parentId: 3,
          state: 0,
          pageNo: 1,
          pageSize: 10
        },
        routeParams: {
          columnId: 3,
          columnName: '破产资讯',
          parentId: 0
        },
        total: 0,
        tableData: []
      }
    },
    mounted() {
      this.getPageList()
    },
    methods: {
      getPageList() {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.NEWS_PAGE_API_URL, 'Json', this.pageParams)
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            this.total = res.data.data.total
            this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错")
        })
      },
      handleCurrentChange(pageNo) {
        this.pageParams.pageNo = pageNo
        this.getPageList()
      },
      handleSizeChange(pageSize) {
        this.pageParams.pageSize = pageSize
        this.getPageList()
      },
      contentTo(id) {
        this.$router.push('/detail/' + id)
      },
      formatDate(date) {
        if(date == undefined){
          return ''
        }
        return this.$moment(date).format("YYYY-MM-DD")
      },
      formatDateDay(date) {
        if(date == undefined){
          return ''
        }
        return this.$moment(date).date()
      }
    }
  }
</script>
<style scoped lang="less">
  .el-pagination {
    text-align: center; 
  }
</style>